import { render, staticRenderFns } from "./SidebarObjectAdded.vue?vue&type=template&id=6a417e4e&scoped=true&"
import script from "./SidebarObjectAdded.vue?vue&type=script&lang=js&"
export * from "./SidebarObjectAdded.vue?vue&type=script&lang=js&"
import style0 from "./SidebarObjectAdded.vue?vue&type=style&index=0&id=6a417e4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a417e4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VIcon,VRow,VSpacer,VTooltip})
